import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";

type SimpleTabsProps = {
  items: { title: string; content: JSX.Element }[];
};

export default function SimpleTabs(props: SimpleTabsProps) {
  const { items } = props;
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange} aria-label="Tabs">
          {items &&
            items.map((t, i) => (
              <Tab label={t.title} {...a11yProps(i)} key={t.title} />
            ))}
        </Tabs>
      </Box>

      {items &&
        items.map((t, i) => (
          <TabPanel value={value} index={i} key={t.title}>
            {t.content}
          </TabPanel>
        ))}
    </Box>
  );
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
